'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _idgen = require('./idgen');

var _idgen2 = _interopRequireDefault(_idgen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SideNav = function SideNav(_ref) {
  var children = _ref.children;
  var _ref$id = _ref.id;
  var id = _ref$id === undefined ? ['sidenav_' + (0, _idgen2.default)()] : _ref$id;
  return _react2.default.createElement(
    'nav',
    null,
    _react2.default.createElement(
      'ul',
      { className: 'right hide-on-med-and-down' },
      children
    ),
    _react2.default.createElement(
      'ul',
      { id: id, className: 'side-nav' },
      children
    ),
    _react2.default.createElement(
      'a',
      { href: '#', 'data-activates': id, className: 'button-collapse' },
      _react2.default.createElement(
        _Icon2.default,
        null,
        'view_headline'
      )
    )
  );
};

SideNav.propTypes = {
  children: _react.PropTypes.node,
  id: _react.PropTypes.string,
  right: _react.PropTypes.bool,
  left: _react.PropTypes.bool
};

exports.default = SideNav;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-materialize/lib/SideNav.js
 ** module id = 133
 ** module chunks = 0
 **/